import { webLightTheme } from "@fluentui/tokens";
import { setTheme } from "@fluentui/web-components/theme/set-theme.js";

setTheme(webLightTheme);